import {
  AssetTypeSearchFilterEnum,
  FileTypeSearchFilterEnum,
  MediaTypeSearchFilterEnum,
} from '../searchParameters';
import { ContentTypeEnum } from './contentType';

export type ContentTypeFacets = Readonly<{
  assetType?: AssetTypeSearchFilterEnum;
  mediaType?: MediaTypeSearchFilterEnum;
  assetFileType?: FileTypeSearchFilterEnum;
}>;

// A search that spans asset types (or is a video-template search) sits in no
// single content type, so it gets none rather than a guess.
// Vectors are EPS illustrations; keep in step with Rails' SearchContext#vector?.
export const contentTypeOf = ({
  assetType,
  mediaType,
  assetFileType,
}: ContentTypeFacets): ContentTypeEnum | undefined => {
  if (assetType === AssetTypeSearchFilterEnum.FILM) return ContentTypeEnum.FILM;
  if (assetType !== AssetTypeSearchFilterEnum.IMAGE) return undefined;
  if (mediaType !== MediaTypeSearchFilterEnum.ILLUSTRATION) {
    return ContentTypeEnum.PHOTOGRAPHY;
  }

  return assetFileType === FileTypeSearchFilterEnum.EPS
    ? ContentTypeEnum.VECTOR
    : ContentTypeEnum.ILLUSTRATION;
};
